/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var mergeHelpers = require("./mergeHelpers");

var checkMergeObjectArg = mergeHelpers.checkMergeObjectArg;
var checkMergeIntoObjectArg = mergeHelpers.checkMergeIntoObjectArg;
/**
 * Shallow merges two structures by mutating the first parameter.
 *
 * @param {object|function} one Object to be merged into.
 * @param {?object} two Optional object with properties to merge from.
 */

function mergeInto(one, two) {
  checkMergeIntoObjectArg(one);

  if (two != null) {
    checkMergeObjectArg(two);

    for (var key in two) {
      if (!Object.prototype.hasOwnProperty.call(two, key)) {
        continue;
      }

      one[key] = two[key];
    }
  }
}

module.exports = mergeInto;